//import { connect } from 'react-redux'


const getAuthToken = () => {
    return localStorage.getItem("AUTH_TOKEN");
}

const setAuthToken = (userId, password) => {

    let data = userId + ":" + password;
    let buff = new Buffer(data);
    let base64data = buff.toString('base64');

    localStorage.setItem("AUTH_TOKEN", base64data);
    console.log("userid/password: " + data + " " + base64data);
}

//setAuthToken("user", "password");

export { getAuthToken, setAuthToken }